/**
 * CORE-1597 — ceilings of the web wizard's «Обложка» step (Prod, 05.10: the
 * step «hung» on a cover pick; skipping it let the master continue).
 *
 * Nothing on the step had a time limit: neither the gallery list, nor the photo
 * through our Unsplash proxy, nor the copy into our storage. A stalled request
 * kept the spinner up and the gallery and buttons disabled for good. The upload
 * itself shares the native wizard's minute (`COVER_UPLOAD_TIMEOUT_MS`).
 */

/** The gallery list: the backend serves it from cache, so 15 s means it is not coming. */
export const COVER_LIST_TIMEOUT_MS = 15_000;

/** The picked photo via `/api/Unsplash/photo`: the backend gives up on Unsplash after 20 s. */
export const COVER_PHOTO_TIMEOUT_MS = 30_000;
